var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "appointments-container"
  }, [_c('main', {
    staticClass: "main-content"
  }, [_c('h1', {
    staticClass: "title-with-underline"
  }, [_vm._v("預約資訊")]), _vm.appointments.length > 0 ? _c('div', {
    staticClass: "appointment-list",
    attrs: {
      "id": "appointmentList"
    }
  }, _vm._l(_vm.appointments, function (appointment, index) {
    return _c('div', {
      key: appointment.id,
      staticClass: "appointment-card",
      class: {
        selected: _vm.selectedAppointment && _vm.selectedAppointment.id === appointment.id
      },
      on: {
        "click": function click($event) {
          return _vm.toggleCard(appointment, index);
        }
      }
    }, [_c('div', {
      staticClass: "appointment-header"
    }, [_c('div', {
      staticClass: "appointment-header-content"
    }, [_c('div', {
      staticClass: "patient-name"
    }, [_vm._v(_vm._s(appointment.patientName))]), _c('div', {
      staticClass: "clinic-name"
    }, [_vm._v(_vm._s(appointment.clinicName))]), _c('div', {
      staticClass: "appointment-summary"
    }, [_c('div', {
      staticClass: "summary-item"
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2"
      }
    }, [_c('rect', {
      attrs: {
        "x": "3",
        "y": "4",
        "width": "18",
        "height": "18",
        "rx": "2",
        "ry": "2"
      }
    }), _c('line', {
      attrs: {
        "x1": "16",
        "y1": "2",
        "x2": "16",
        "y2": "6"
      }
    }), _c('line', {
      attrs: {
        "x1": "8",
        "y1": "2",
        "x2": "8",
        "y2": "6"
      }
    }), _c('line', {
      attrs: {
        "x1": "3",
        "y1": "10",
        "x2": "21",
        "y2": "10"
      }
    })]), _c('span', {
      staticClass: "summary-value"
    }, [_vm._v(_vm._s(appointment.dateTime))])]), _c('span', {
      staticClass: "appointment-type"
    }, [_vm._v(_vm._s(appointment.type))])])]), _c('button', {
      staticClass: "expand-btn",
      class: {
        expanded: _vm.expandedCards[index]
      }
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2"
      }
    }, [_c('polyline', {
      attrs: {
        "points": "6 9 12 15 18 9"
      }
    })])])]), _c('div', {
      staticClass: "appointment-details",
      class: {
        show: _vm.expandedCards[index]
      }
    }, [_c('div', {
      staticClass: "appointment-info"
    }, [appointment.number ? _c('div', {
      staticClass: "info-row"
    }, [_c('span', {
      staticClass: "info-label"
    }, [_vm._v("現場號碼")]), _c('span', {
      staticClass: "info-value highlight"
    }, [_vm._v(_vm._s(appointment.number))])]) : _vm._e(), appointment.department ? _c('div', {
      staticClass: "info-row"
    }, [_c('span', {
      staticClass: "info-label"
    }, [_vm._v("看診科別")]), _c('span', {
      staticClass: "info-value department"
    }, [_vm._v(_vm._s(appointment.department))])]) : _vm._e(), appointment.doctor ? _c('div', {
      staticClass: "info-row"
    }, [_c('span', {
      staticClass: "info-label"
    }, [_vm._v("看診醫師")]), _c('span', {
      staticClass: "info-value"
    }, [_vm._v(_vm._s(appointment.doctor))])]) : _vm._e(), appointment.identity ? _c('div', {
      staticClass: "info-row"
    }, [_c('span', {
      staticClass: "info-label"
    }, [_vm._v("看診身分")]), _c('span', {
      staticClass: "info-value"
    }, [_vm._v(_vm._s(appointment.identity))])]) : _vm._e(), appointment.checkupItem ? _c('div', {
      staticClass: "info-row"
    }, [_c('span', {
      staticClass: "info-label"
    }, [_vm._v("健檢項目")]), _c('span', {
      staticClass: "info-value"
    }, [_vm._v(_vm._s(appointment.checkupItem))])]) : _vm._e(), _c('div', {
      staticClass: "info-row"
    }, [_c('span', {
      staticClass: "info-label"
    }, [_vm._v("預約狀態")]), _c('span', {
      staticClass: "info-value status confirmed"
    }, [_vm._v(_vm._s(appointment.status))])])])])]);
  }), 0) : _vm._e(), _vm.appointments.length === 0 ? _c('div', {
    staticClass: "empty-state"
  }, [_c('div', {
    staticClass: "empty-icon"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 6v6l4 2"
    }
  })])]), _c('p', {
    staticClass: "empty-text"
  }, [_vm._v("您目前沒有預約紀錄")]), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.goToBooking
    }
  }, [_vm._v("立即預約")])]) : _vm._e()]), _c('div', {
    staticClass: "button-section"
  }, [_c('div', {
    staticClass: "button-group"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": !_vm.selectedAppointment
    },
    on: {
      "click": _vm.showCancelModal
    }
  }, [_vm._v("取消預約")])])]), _c('div', {
    staticClass: "tongxin-modal",
    class: {
      show: _vm.showCancelConfirmModal
    }
  }, [_c('div', {
    staticClass: "tongxin-modal__content"
  }, [_c('div', {
    staticClass: "tongxin-modal__header"
  }, [_c('div', {
    staticClass: "tongxin-modal__icon"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('line', {
    attrs: {
      "x1": "15",
      "y1": "9",
      "x2": "9",
      "y2": "15"
    }
  }), _c('line', {
    attrs: {
      "x1": "9",
      "y1": "9",
      "x2": "15",
      "y2": "15"
    }
  })])]), _c('h2', {
    staticClass: "tongxin-modal__title"
  }, [_vm._v("確認取消預約")])]), _c('div', {
    staticClass: "tongxin-modal__body"
  }, [_vm._m(0), _vm.selectedAppointment ? _c('div', {
    staticClass: "cancel-info-box"
  }, [_c('div', {
    staticClass: "cancel-info-item"
  }, [_c('span', {
    staticClass: "cancel-info-label"
  }, [_vm._v("看診人")]), _c('span', {
    staticClass: "cancel-info-value highlight"
  }, [_vm._v(_vm._s(_vm.selectedAppointment.patientName))])]), _c('div', {
    staticClass: "cancel-info-item"
  }, [_c('span', {
    staticClass: "cancel-info-label"
  }, [_vm._v("診所名稱")]), _c('span', {
    staticClass: "cancel-info-value"
  }, [_vm._v(_vm._s(_vm.selectedAppointment.clinicName))])]), _c('div', {
    staticClass: "cancel-info-item"
  }, [_c('span', {
    staticClass: "cancel-info-label"
  }, [_vm._v("看診日期")]), _c('span', {
    staticClass: "cancel-info-value highlight"
  }, [_vm._v(_vm._s(_vm.selectedAppointment.dateTime))])]), _c('div', {
    staticClass: "cancel-info-item"
  }, [_c('span', {
    staticClass: "cancel-info-label"
  }, [_vm._v("掛號類型")]), _c('span', {
    staticClass: "cancel-info-value"
  }, [_vm._v(_vm._s(_vm.selectedAppointment.type))])])]) : _vm._e()]), _c('div', {
    staticClass: "tongxin-modal__buttons"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("取消")]), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.confirmCancel
    }
  }, [_vm._v("確認取消")])])])]), _c('div', {
    staticClass: "tongxin-modal",
    class: {
      show: _vm.showResultModal
    }
  }, [_c('div', {
    staticClass: "tongxin-modal__content"
  }, [_c('div', {
    staticClass: "tongxin-modal__header"
  }, [_c('div', {
    staticClass: "tongxin-modal__icon result-modal-icon",
    class: {
      success: _vm.resultSuccess,
      error: !_vm.resultSuccess
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_vm.resultSuccess ? [_c('path', {
    attrs: {
      "d": "M22 11.08V12a10 10 0 1 1-5.93-9.14"
    }
  }), _c('polyline', {
    attrs: {
      "points": "22 4 12 14.01 9 11.01"
    }
  })] : [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('line', {
    attrs: {
      "x1": "15",
      "y1": "9",
      "x2": "9",
      "y2": "15"
    }
  }), _c('line', {
    attrs: {
      "x1": "9",
      "y1": "9",
      "x2": "15",
      "y2": "15"
    }
  })]], 2)]), _c('h2', {
    staticClass: "tongxin-modal__title"
  }, [_vm._v(_vm._s(_vm.resultTitle))])]), _c('div', {
    staticClass: "tongxin-modal__body"
  }, [_c('p', {
    staticClass: "tongxin-modal__text"
  }, [_vm._v(_vm._s(_vm.resultMessage))]), _vm.errorReason ? _c('div', {
    staticClass: "error-reason"
  }, [_c('div', {
    staticClass: "error-reason-title"
  }, [_vm._v("錯誤原因")]), _c('div', {
    staticClass: "error-reason-text"
  }, [_vm._v(_vm._s(_vm.errorReason))])]) : _vm._e()]), _c('div', {
    staticClass: "tongxin-modal__buttons"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "flex-grow": "1"
    },
    on: {
      "click": _vm.closeResultModal
    }
  }, [_vm._v("確定")])])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "tongxin-modal__text"
  }, [_vm._v(" 確定要取消以下預約嗎？"), _c('br'), _vm._v(" 取消後將無法復原，需重新預約。 ")]);
}]

export { render, staticRenderFns }